<template>
  <div class="myCenter-left">
    <div class="list-box">
      <router-link class="myShow listCur" tag="div" :to="{path:'/MyCenter/mine'}">
        <div class="img">
          <img v-if="currentChild.student_img !=''" :src="currentChild.student_img" alt />
          <img v-else-if="currentChild.student_img =='' && currentChild.student_sex ==$t('Common.woman')" src="@/assets/images/childWoman.png" alt />
           <img v-else-if="currentChild.student_img =='' && currentChild.student_sex ==$t('Common.man')" src="@/assets/images/childMan.png" alt />
          <img v-else-if="currentChild.student_img =='' && currentChild.student_sex ==''" src="@/assets/images/childImg.png" alt />
        </div>
        <p class="one nameCur">
          <span class="name" style="margin-right:6px">{{currentChild.student_cnname }}</span>
          <img
            v-if="currentChild.student_sex == $t('Common.woman')"
            src="@/assets/images/myCenter/woman.png"
            alt
          />
          <img v-if="currentChild.student_sex == $t('Common.man')" src="@/assets/images/myCenter/man.png" alt />
        </p>
        <p class="two">{{currentChild.class_cnname}}</p>
      </router-link>
      <router-link tag="p" class="listCur list" :to="{path:'/MyCenter/rewardSource'}">
        <em class="icon-jiangli"></em>
        <span class="nameCur">{{$store.state.globalTxt.member1?this.$store.state.globalTxt.member1:$t('MyCenter.reword')}}</span>
      </router-link>
      <router-link tag="p" class="listCur list" :to="{path:'/MyCenter/learnCount'}">
        <em class="icon-xuexitongji"></em>
        <span class="nameCur">{{$store.state.globalTxt.member2?this.$store.state.globalTxt.member2:$t('MyCenter.studyCount')}}</span>
      </router-link>
      <router-link tag="p" class="listCur list" :to="{path:'/MyCenter/learnTrack'}">
        <em class="icon-xuexiguiji"></em>
        <span class="nameCur">{{$store.state.globalTxt.member3?this.$store.state.globalTxt.member3:$t('MyCenter.trace')}}</span>
      </router-link>
      <router-link tag="p" class="listCur list" :to="{path:'/MyCenter/setting'}">
        <em class="icon-shezhi"></em>
        <span class="nameCur">{{$t('MyCenter.setting')}}</span>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "sideBar",
  components: {},
  data() {
    return {
      urlFlag: 0 //当前是个人中心的 当前页面的 标识
    };
  },
  mounted() {},
  updated() {},
  created() {},
  computed: {
    currentChild() {
      return this.$store.state.currentChild;
    }
  },
  watch: {
    $route(to, from, next) {
      let nowPath = to.name;
      if (nowPath == "mine") {
        this.urlFlag = 0;
      } else if (nowPath == "rewardSource") {
        this.urlFlag = 1;
      } else if (nowPath == "learnCount") {
        this.urlFlag = 2;
      } else if (nowPath == "learnTrack") {
        this.urlFlag = 3;
      } else if (nowPath == "setting") {
        this.urlFlag = 4;
      }
    }
  },
  methods: {
    changeUrl(val) {
      if (val == 0) {
        this.urlFlag = 0;
      } else if (val == 1) {
        this.urlFlag = 1;
      } else if (val == 2) {
        this.urlFlag = 2;
      } else if (val == 3) {
        this.urlFlag = 3;
      } else if (val == 4) {
        this.urlFlag = 4;
      }
    }
  }
};
</script>

<style lang="less">
.one {
  .name {
    color: #666;
    font-size: 12px;
  }
}
.list {
  cursor: pointer;
}
.listCur{
  cursor: pointer;
}
</style>
